import React, { Component } from 'react';
import { withIonLifeCycle } from '@ionic/react';

import { routerActions } from '$gbusiness/redux/router';
import store from '$business/redux'; // PRODUCT DEPENDENCY
import { clog } from '$gbusiness/helpers';
import UserModel from '$gbusiness/models/user';

interface AsScreenViewProps {
  onHydrate?: Function;
  onDehydrate?: Function;
  match?: any;
  history?: any;
  user?: UserModel;
  resetOnRoute?: false;
}

const screen = (ScreenView): any => {
  class AsScreenView extends Component<AsScreenViewProps> {
    static defaultProps: AsScreenViewProps = {
      onHydrate: () => {},
      onDehydrate: () => {},
    };

    state = {
      isDestroyed: false,
    };

    ionViewWillEnter() {
      const { match, resetOnRoute } = this.props;

      if (resetOnRoute) this.setState({ isDestroyed: false });
      if (match && match.path) {
        store.dispatch(routerActions.setRoute(match.url, match?.params, match.path));
      }
      if (this.props.onHydrate) this.props.onHydrate(match?.params);
    }

    ionViewWillLeave() {
      const { onDehydrate, resetOnRoute } = this.props;
      if (onDehydrate) onDehydrate();
      if (resetOnRoute) this.setState({ isDestroyed: true });
    }

    render() {
      if (this.state.isDestroyed) {
        clog('DESTROYED', this.props.match?.url);
        return null;
      }

      return <ScreenView {...this.props} />;
    }
  }

  return withIonLifeCycle(AsScreenView);
};

export default screen;
